(() => {
  const root = document.querySelector(".ha-quiz");
  if (!root) return;

  const form = root.querySelector("[data-quiz]");
  const screens = [...form.querySelectorAll("[data-screen]")];
  const progressFill = root.querySelector("[data-progress]");
  const stepCounter = root.querySelector("[data-step-counter]");
  const backBtn = root.querySelector("[data-back]");
  const ctaUrl = root.dataset.ctaUrl || "/collections/all";
  // Screens past the loader = the payoff. Hide quiz chrome + use brand CTA.
  const RESULT_PHASE = new Set(["summary", "map", "bridge", "result"]);
  const applyChrome = (name) =>
    root.classList.toggle("ha-quiz--result-phase", RESULT_PHASE.has(name));
  const summaryLabels = {
    age: "Age range",
    body: "Where you feel it",
    symptoms: "Recent symptoms",
    stage: "Stage",
    puffiness: "Bloating timing",
    tried: "What you've tried",
    consistency: "Supplement consistency",
    sleep: "Sleep",
    goals: "Goals",
  };

  const total = screens.length;
  let index = 0;
  const history = [];
  let lastFocus = ""; // primary focus area, carried from summary into the offer

  // Funnel instrumentation: GA4/Elevar (dataLayer) + Triple Whale (TriplePixel)
  // + first-party warehouse (master-dashboard beacon -> BigQuery ops_config.quiz_events)
  const BEACON_URL = "https://master-dashboard-qb1w.onrender.com/api/quiz/track";
  const sid = (function () {
    try {
      let v = sessionStorage.getItem("ha_quiz_sid");
      if (!v) {
        v = "q-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
        sessionStorage.setItem("ha_quiz_sid", v);
      }
      return v;
    } catch (e) { return "q-" + Math.random().toString(36).slice(2, 14); }
  })();
  let beaconBuffer = [];

  function flushBeacon() {
    if (!beaconBuffer.length) return;
    const events = beaconBuffer;
    beaconBuffer = [];
    try {
      const blob = new Blob(
        [JSON.stringify({ quiz: "bloating", session_id: sid, events: events })],
        { type: "text/plain" } // simple request: no CORS preflight
      );
      if (navigator.sendBeacon) navigator.sendBeacon(BEACON_URL, blob);
    } catch (e) { /* never break the quiz */ }
  }

  function track(event, data) {
    try {
      const payload = Object.assign({ quiz: "bloating" }, data || {});
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: event }, payload));
      }
      if (typeof window.TriplePixel === "function") {
        window.TriplePixel("custom", event, payload);
      }
      beaconBuffer.push(Object.assign({ event: event, ts: Date.now() }, data || {}));
      if (
        beaconBuffer.length >= 12 ||
        event === "quiz_complete" ||
        event === "quiz_cta_click"
      ) {
        flushBeacon();
      }
    } catch (e) { /* analytics must never break the quiz */ }
  }

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") flushBeacon();
  });
  window.addEventListener("pagehide", flushBeacon);

  function setStep(next, push = true) {
    if (next < 0 || next >= screens.length) return;
    if (push && next !== index) history.push(index);
    screens[index].classList.remove("is-active");
    index = next;
    const screen = screens[index];
    screen.classList.add("is-active");

    const pct = Math.round(((index + 1) / total) * 100);
    progressFill.style.width = pct + "%";
    stepCounter.textContent = `${index + 1} / ${total}`;
    backBtn.hidden = history.length === 0;

    window.scrollTo({ top: 0, behavior: "smooth" });

    const screenName = screen.dataset.screen;
    applyChrome(screenName);
    location.hash = screenName;
    track("quiz_step", { step: screenName, index: index + 1, total: total });

    if (screenName === "loader") runLoader(screen);
    if (screenName === "trust") initCarousel(screen);
    if (screenName === "summary") renderSummary(screen);
    if (screenName === "map") renderMap(screen);
    if (screenName === "bridge") renderBridge(screen);
    if (screenName === "result") {
      const focusEl = screen.querySelector("[data-offer-focus]");
      if (focusEl && lastFocus) {
        focusEl.textContent = "Your #1 focus: " + lastFocus;
        focusEl.hidden = false;
      }
      const cta = screen.querySelector("[data-cta]");
      if (cta) {
        cta.href = ctaUrl;
        if (!cta.dataset.trackBound) {
          cta.dataset.trackBound = "1";
          cta.addEventListener("click", function () {
            track("quiz_cta_click", { step: "result" });
          });
        }
      }
    }

    setTimeout(() => {
      const firstInput = screen.querySelector("input");
      if (firstInput) firstInput.focus({ preventScroll: true });
    }, 50);
  }

  function isAnswered(screen) {
    if (!screen.hasAttribute("data-required")) return true;
    const inputs = screen.querySelectorAll("input[type=radio], input[type=checkbox]");
    return [...inputs].some((i) => i.checked);
  }

  function runLoader(screen) {
    const items = [...screen.querySelectorAll("[data-step]")];
    const ms = parseInt(screen.dataset.autoAdvance || "4500", 10);
    const each = Math.max(400, Math.floor(ms / items.length));
    items.forEach((it) => it.classList.remove("is-active", "is-done"));
    items.forEach((item, i) => {
      setTimeout(() => {
        items.forEach((x) => x.classList.remove("is-active"));
        item.classList.add("is-active");
        if (i > 0) items[i - 1].classList.add("is-done");
      }, each * i);
    });
    setTimeout(() => {
      items.forEach((x) => x.classList.remove("is-active"));
      items.forEach((x) => x.classList.add("is-done"));
      setStep(index + 1);
    }, each * items.length);
  }

  function getAnswers() {
    const data = new FormData(form);
    const out = {};
    for (const [k, v] of data.entries()) {
      if (out[k] === undefined) out[k] = v;
      else if (Array.isArray(out[k])) out[k].push(v);
      else out[k] = [out[k], v];
    }
    return out;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  }

  function listPhrase(a) {
    if (!a.length) return "the changes you described";
    if (a.length === 1) return a[0];
    if (a.length === 2) return a[0] + " and " + a[1];
    return a.slice(0, -1).join(", ") + ", and " + a[a.length - 1];
  }

  // Map each bloat signal she reports to what the formula does about it, with a
  // distinct colour per system so the map reads visually, not monochromatically.
  function buildInsights(answers) {
    const arr = (k) => (answers[k] ? (Array.isArray(answers[k]) ? answers[k] : [answers[k]]) : []);
    const symptoms = arr("symptoms");
    const goals = arr("goals");
    const sleep = answers.sleep || "";
    const stage = answers.stage || "";
    const puff = answers.puffiness || "";
    const symHas = (s) => symptoms.some((x) => x.toLowerCase().includes(s));
    const goalHas = (s) => goals.some((x) => x.toLowerCase().includes(s));
    const peri = stage === "Starting to change" || stage === "Mostly stopped" || stage === "Stopped completely";

    const catalog = [
      {
        on: symHas("bloating after") || symHas("gassy") || symHas("sluggish") || goalHas("digestion") || puff === "After meals",
        pain: "You bloat after normal meals",
        action: "Digestive antioxidants and circulation support help meals settle, so the after-meal bloat eases.",
        tone: "#9caf88", icon: "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z",
      },
      {
        on: symHas("puffiness") || symHas("water") || symHas("face looks puffier") || goalHas("puffiness"),
        pain: "You hold water and feel puffy",
        action: "Hormone Harmony supports healthy water balance, so you hold less and feel lighter.",
        tone: "#a1add8", icon: "M3 12c3-4 5-4 8 0s5 4 8 0",
      },
      {
        on: symHas("mood") || peri || puff === "Around cycle" || goalHas("myself"),
        pain: "Your hormones are shifting",
        action: "Maca and chaste berry (Vitex) steady the hormonal shift that drives the bloat.",
        tone: "#da9897", icon: "M12 21C5 14 4 9 7 6c2-2 4-1 5 1 1-2 3-3 5-1 3 3 2 8-5 15z",
      },
      {
        on: symHas("waistband") || symHas("weight that will not move") || goalHas("weight") || goalHas("clothes"),
        pain: "Your waistband feels tight and weight won't move",
        action: "Metabolic support helps as hormones change, so clothes start to fit comfortably again.",
        tone: "#d0535b", icon: "M4 14l5-5 4 4 6-7",
      },
      {
        on: sleep.indexOf("Wakes") > -1 || sleep.indexOf("Trouble") > -1 || sleep.indexOf("tired") > -1,
        pain: "Your sleep doesn't leave you rested",
        action: "L-theanine supports calmer cortisol and deeper rest, which also eases water retention.",
        tone: "#8a96c4", icon: "M21 13a9 9 0 11-7.5-8.86A7 7 0 0021 13z",
      },
      {
        on: goalHas("energy"),
        pain: "Your energy isn't steady",
        action: "NAD+ precursors, CoQ10, and PQQ fuel steady energy through the day.",
        tone: "#e6c389", icon: "M13 2L3 14h7l-1 8 10-12h-7l1-8z",
      },
    ];
    return catalog.filter((c) => c.on);
  }

  function renderMap(screen) {
    let insights = buildInsights(getAnswers());
    if (insights.length < 2) {
      const fb = [
        { pain: "Bloating and puffiness build through the day", action: "Hormone Harmony and antioxidants support water balance, so you feel lighter.", tone: "#a1add8", icon: "M3 12c3-4 5-4 8 0s5 4 8 0" },
        { pain: "Digestion slows as hormones shift", action: "Daily support helps meals settle and the bloat ease, day after day.", tone: "#9caf88", icon: "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z" },
      ];
      fb.forEach((f) => { if (insights.length < 2) insights.push(f); });
    }
    insights = insights.slice(0, 4);
    const list = screen.querySelector("[data-map-list]");
    if (!list) return;
    list.innerHTML = insights
      .map(
        (i) =>
          '<li class="ha-map__row" style="--tone:' + (i.tone || "#9caf88") + '">' +
          '<span class="ha-map__icon" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 24 24" fill="none"><path d="' + (i.icon || "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z") + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<div class="ha-map__body">' +
          '<p class="ha-map__pain">' + escapeHtml(i.pain) + "</p>" +
          '<p class="ha-map__action"><span class="ha-map__arrow" aria-hidden="true">&rarr;</span>' + escapeHtml(i.action) + "</p>" +
          "</div></li>"
      )
      .join("");
  }

  function renderSummary(screen) {
    const answers = getAnswers();
    const arr = (k) => (answers[k] ? (Array.isArray(answers[k]) ? answers[k] : [answers[k]]) : []);

    // Subscores 0-100 (higher = better / less of a problem)
    const symptoms = arr("symptoms");
    const goals = arr("goals");
    const sleep = answers.sleep || "";
    const tried = answers.tried || "";
    const consistency = answers.consistency || "";
    const location = answers.body || "";
    const timing = answers.puffiness || "";
    const stage = answers.stage || "";

    const symHas = (s) => symptoms.some((x) => x.toLowerCase().includes(s));
    const goalHas = (s) => goals.some((x) => x.toLowerCase().includes(s));

    // 1. Digestion & gut comfort  (data-card="energy")
    let energy = 70;
    if (symHas("heavy") || symHas("sluggish")) energy -= 22;
    if (symHas("gassy")) energy -= 18;
    if (symHas("bloating after")) energy -= 18;
    if (timing === "After meals") energy -= 12;
    if (tried === "Nothing yet") energy -= 8;

    // 2. Hormonal water balance  (data-card="body")
    let bodyScore = 70;
    if (stage === "Starting to change") bodyScore -= 18;
    else if (stage === "Mostly stopped" || stage === "Stopped completely") bodyScore -= 25;
    if (symHas("water retention") || symHas("puffiness")) bodyScore -= 16;
    if (timing === "Around cycle") bodyScore -= 14;
    if (location === "Hands and fingers" || location === "Legs, ankles, or feet") bodyScore -= 10;

    // 3. Sleep & cortisol  (data-card="digestion")
    let digestion = 70;
    if (sleep.includes("Wakes") || sleep.includes("Trouble") || sleep.includes("tired")) digestion -= 26;
    if (sleep === "Solid") digestion += 12;
    if (sleep === "Depends") digestion -= 10;
    if (goalHas("energy")) digestion -= 6;

    // 4. Bloating & puffiness  (data-card="micronutrients")
    let micro = 70;
    if (symHas("waistband") || symHas("bloating")) micro -= 24;
    if (symHas("face")) micro -= 10;
    if (timing === "Morning" || timing === "End of day" || timing === "Random") micro -= 12;
    if (consistency.includes("Forget") || consistency === "Hit or miss") micro -= 10;

    const clamp = (n) => Math.max(8, Math.min(95, Math.round(n)));
    energy = clamp(energy);
    bodyScore = clamp(bodyScore);
    digestion = clamp(digestion);
    micro = clamp(micro);

    const overall = Math.round((energy + bodyScore + digestion + micro) / 4);

    const labelFor = (n) =>
      n < 30 ? "Low" :
      n < 55 ? "Fair" :
      n < 75 ? "Good" :
      "Strong";

    const badgeFor = (n) =>
      n < 25 ? "LOW" :
      n < 50 ? "LOW-MODERATE" :
      n < 70 ? "MODERATE" :
      n < 85 ? "GOOD" :
      "HIGH";

    screen.querySelector("[data-result-badge]").textContent = badgeFor(overall);
    const fill = screen.querySelector("[data-gauge-fill]");
    const marker = screen.querySelector("[data-gauge-marker]");
    if (fill) fill.style.width = overall + "%";
    if (marker) marker.style.left = overall + "%";

    // Each system card: short status word + a visual level meter (low = amber)
    const applyCard = (cardKey, meterKey, n) => {
      const val = screen.querySelector("[data-card='" + cardKey + "']");
      if (val) { val.textContent = labelFor(n); val.classList.toggle("ha-result__card-value--low", n < 40); }
      const fillEl = screen.querySelector("[data-meter='" + meterKey + "']");
      if (fillEl) { fillEl.style.width = Math.max(6, n) + "%"; fillEl.classList.toggle("ha-result__meter-fill--low", n < 40); }
    };
    applyCard("energy", "energy", energy);
    applyCard("body", "body", bodyScore);
    applyCard("digestion", "digestion", digestion);
    applyCard("micronutrients", "micro", micro);

    const focusMap = { energy: "Digestion & gut comfort", body: "Hormonal water balance", digestion: "Sleep & cortisol", micro: "Bloating & puffiness" };
    const subs = { energy: energy, body: bodyScore, digestion: digestion, micro: micro };
    const weakest = Object.keys(subs).reduce((a, b) => (subs[a] <= subs[b] ? a : b));
    const focusEl = screen.querySelector("[data-primary-focus]");

    // Link the primary focus + plan to her GOALS: the goal area that needs most
    // support today (weakest scored system among her goals). phrase feeds the lead.
    const goalMap = {
      "A flatter, calmer stomach": { sys: "micro", phrase: "feel flatter" },
      "Less puffiness and water retention": { sys: "micro", phrase: "feel less puffy" },
      "Clothes that fit comfortably again": { sys: "micro", phrase: "fit your clothes again" },
      "Better digestion": { sys: "energy", phrase: "improve digestion" },
      "Steadier energy": { sys: "energy", phrase: "have steadier energy" },
      "Support healthy weight": { sys: "body", phrase: "support healthy weight" },
      "Feel like myself again": { sys: "body", phrase: "feel like yourself again" },
    };
    const goalSystems = {};
    const goalPhrases = [];
    goals.forEach((g) => {
      const m = goalMap[g];
      if (m) { goalSystems[m.sys] = true; if (goalPhrases.indexOf(m.phrase) === -1) goalPhrases.push(m.phrase); }
    });
    const hasGoals = goalPhrases.length > 0;
    const scoredGoals = Object.keys(goalSystems).filter((k) => subs[k] !== undefined);
    let focusKey = weakest;
    if (scoredGoals.length) focusKey = scoredGoals.reduce((a, b) => (subs[a] <= subs[b] ? a : b));
    if (focusEl) focusEl.textContent = focusMap[focusKey];
    lastFocus = focusMap[focusKey];

    // Spotlight the card matching her goal-focus (micro -> micronutrients card)
    const cardKeyForFocus = focusKey === "micro" ? "micronutrients" : focusKey;
    screen.querySelectorAll(".ha-result__card").forEach((card) => {
      const v = card.querySelector("[data-card]");
      card.classList.toggle("ha-result__card--focus", !!(v && v.getAttribute("data-card") === cardKeyForFocus));
    });

    // Highlight the plan blends tied to her goals (or the weakest system if she
    // marked none) and tag them "Your goal".
    screen.querySelectorAll("[data-blend-system]").forEach((el) => {
      const match = hasGoals ? !!goalSystems[el.dataset.blendSystem] : el.dataset.blendSystem === weakest;
      el.classList.toggle("ha-plan__blend--focus", match);
      const tag = el.querySelector("[data-blend-tag]");
      if (tag) tag.hidden = !match;
    });
    const leadEl = screen.querySelector(".ha-plan__lead");
    if (leadEl && hasGoals) {
      leadEl.innerHTML = "You want to <strong>" + escapeHtml(listPhrase(goalPhrases.slice(0, 3))) + "</strong>. This plan targets it.";
    }

    // Personalize alert copy
    const title = screen.querySelector("[data-alert-title]");
    const copy = screen.querySelector("[data-alert-copy]");
    if (overall < 50) {
      title.textContent = "Your body is holding onto bloat and puffiness.";
      copy.textContent = "As hormones shift, digestion slows and the body holds more water. That's what's behind the bloat and the tight waistband.";
    } else if (overall < 75) {
      title.textContent = "You're managing it, with room to feel lighter day to day.";
      copy.textContent = "Targeted support for hormones, water balance, and cellular energy helps most women feel flatter within a few weeks.";
    } else {
      title.textContent = "You're in a good place.";
      copy.textContent = "Consistent daily support keeps hormones and water balance steady, so the bloat stays away.";
    }

    try {
      sessionStorage.setItem(
        "ha_quiz_bloating_answers",
        JSON.stringify({ answers, scores: { overall, energy, body: bodyScore, digestion, micro } })
      );
    } catch (e) {}

    track("quiz_complete", {
      score: overall,
      badge: badgeFor(overall),
      focus: focusMap[focusKey],
    });
  }

  // Projection: stamp a personalized ~12-week date on the bridge screen
  function renderBridge(screen) {
    const el = screen.querySelector("[data-projection-date]");
    if (!el) return;
    const d = new Date();
    d.setDate(d.getDate() + 84);
    el.textContent = d.toLocaleDateString("en-US", { month: "long", day: "numeric" });
  }

  // Carousel
  function initCarousel(screen) {
    const car = screen.querySelector("[data-carousel]");
    if (!car || car.dataset.inited === "1") return;
    car.dataset.inited = "1";
    const track = car.querySelector("[data-track]");
    const slides = track.children;
    const dots = [...car.querySelectorAll("[data-dot]")];
    const prev = car.querySelector("[data-prev]");
    const next = car.querySelector("[data-next-slide]");
    const autoplayMs = parseInt(car.dataset.autoplay || "0", 10);
    let i = 0;
    let timer = null;

    const render = () => {
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
    };
    const go = (delta) => {
      i = (i + delta + slides.length) % slides.length;
      render();
      restart();
    };
    const restart = () => {
      if (!autoplayMs) return;
      clearInterval(timer);
      timer = setInterval(() => go(1), autoplayMs);
    };
    prev.addEventListener("click", (e) => { e.stopPropagation(); go(-1); });
    next.addEventListener("click", (e) => { e.stopPropagation(); go(1); });
    dots.forEach((d, idx) => d.addEventListener("click", (e) => { e.stopPropagation(); i = idx; render(); restart(); }));

    // touch swipe
    let startX = 0;
    track.addEventListener("touchstart", (e) => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener("touchend", (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });

    render();
    restart();
  }

  // wire up "next" buttons
  form.addEventListener("click", (e) => {
    const next = e.target.closest("[data-next]");
    if (!next) return;
    e.preventDefault();
    const screen = screens[index];
    if (!isAnswered(screen)) {
      next.animate(
        [
          { transform: "translateX(0)" },
          { transform: "translateX(-6px)" },
          { transform: "translateX(6px)" },
          { transform: "translateX(0)" },
        ],
        { duration: 240 }
      );
      return;
    }
    setStep(index + 1);
  });

  // auto-advance for radio (single-select), not checkbox
  form.addEventListener("change", (e) => {
    const screen = screens[index];
    if (e.target.type === "radio" || e.target.type === "checkbox") {
      track("quiz_answer", {
        question: e.target.name,
        value: e.target.value,
        checked: e.target.checked !== false,
      });
    }
    if (e.target.type !== "radio") return;
    if (screen.hasAttribute("data-multi")) return;
    setTimeout(() => setStep(index + 1), 220);
  });

  // back
  backBtn.addEventListener("click", () => {
    if (!history.length) return;
    const prev = history.pop();
    screens[index].classList.remove("is-active");
    index = prev;
    screens[index].classList.add("is-active");
    const pct = Math.round(((index + 1) / total) * 100);
    progressFill.style.width = pct + "%";
    stepCounter.textContent = `${index + 1} / ${total}`;
    backBtn.hidden = history.length === 0;
    applyChrome(screens[index].dataset.screen);
    window.scrollTo({ top: 0, behavior: "smooth" });
    location.hash = screens[index].dataset.screen;
  });

  // initial
  progressFill.style.width = `${Math.round((1 / total) * 100)}%`;
  stepCounter.textContent = `1 / ${total}`;
  track("quiz_view", { step: "age", index: 1, total: total });

  // SmartCart on hydration, close it so it can't cover the quiz. Belt-and-suspenders.
  function closeRebuy() {
    try { if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.hide === "function") Rebuy.SmartCart.hide(); } catch (e) {}
  }
  document.addEventListener("rebuy.ready", closeRebuy);
  [800, 2000, 4000, 7000].forEach(function (t) { setTimeout(closeRebuy, t); });
})();
